import ProMembershipInvoiceCN from './ProMembershipInvoiceCN';

export default ProMembershipInvoiceCN;

